import { Alert } from 'antd'

export function DisplayAlert({ message }: { message: string }) {
  return (
    <>
      <Alert
        style={{
          top: '45%',
          zIndex: 1001,
          width: '50%',
          left: '25%',
        }}
        className="absolute"
        message="錯誤"
        description={message}
        type="error"
        showIcon
      />
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: '#000',
        }}
      />
    </>
  )
}
